<template>
  <div class="">
    <el-row
      class="flex flex-col gap-2 items-start w-full"
      v-if="
        field.input_type != 'CHECKBOX_GROUP' ||
        (field.group_key &&
          field.input_type != 'CHECKBOX' &&
          !(field.input_type == 'WEEKDAYS' && field.allow_multiple))
      "
    >
      <div class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1">
        Field Required!
      </div>
      <div class="form-group">
        <el-radio v-model="field.validations.required" :label="true">Yes</el-radio>
        <el-radio v-model="field.validations.required" :label="false">No</el-radio>
      </div>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-IsFieldRequired',
    props: ['field'],
    data() {
      return {};
    },
  };
</script>

<style lang="scss"></style>
